import React, { useEffect, useState } from "react";
import styled from "styled-components";
import {
  CurrentReservation,
  PubTournament,
  PubType,
  TimerInfoState,
} from "../../../../api/types";
import { useHistory } from "react-router-dom";
import { isRunner } from "../../../../utils/common";
import { useRecoilValue } from "recoil";
import { userState } from "../../../../recoil/auth";
import { enqueueSnackbar } from "notistack";
import { cancelCompanyReservation } from "../../../../api/reservation-company";
import { reservationCancel } from "../../../../api/reservation";

const TournamentWrapper = styled.div<{ progress: number }>`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;

  margin-top: 20px;
  padding: 16px;
  width: 100%;
  border-radius: 8px;

  background: white;
  color: black;

  .col {
    position: relative;
    display: flex;
    flex-direction: column;
  }

  .row {
    justify-content: space-between;
    display: flex;
    flex-direction: row;
  }

  .content {
    width: 100%;
    .line {
      border: 1px solid rgba(0, 0, 0, 1);
    }
  }

  .current {
    color: black;
    background: rgba(236, 240, 243, 1);
    height: 41px;
    border-radius: 8px;
    flex: 1;
  }

  .next {
    color: white;
    background: rgba(217, 217, 217, 1);
    height: 41px;
    border-radius: 8px;
    flex: 1;
  }

  .blind-col {
    gap: 5px;
    .blind-name {
      padding: 6px 6px 0px 6px;
      width: 100%;
      
      font-size: 8px;
      font-weight: 500;
      line-height: 9.55px;
      text-align: left;
    }

    .blind {
      padding: 5px;
      
      font-size: 10px;
      font-weight: 600;
      line-height: 11.93px;
      text-align: left;
    }
  }

  .time-lv {
    justify-content: start;

    .time-box {
      position: relative;
      margin-top: 12px;
      width: 73px;
      height: 73px;
      border-radius: 14px;
      background: rgba(100, 54, 231, 1);
      display: flex;
      justify-content: center;
      align-items: center;

      .donut-container {
        position: relative;
        top: 8px;
        left: 8px;
        width: 57px;
        height: 57px;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .donut-border {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border-radius: 100%;
        border: 4px solid transparent;
        border-color: white;
      }

      .donut-progress {
        position: absolute;
        right: 0px;
        transform: rotateZ(${(props) => 360 - (360 * props.progress) / 100}deg);
      }

      .time {
        color: white;
        font-size: 14px;
        font-weight: bold;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
    .lv-col {
      margin-top: 12px;
      margin-left: 12px;
      justify-content: space-between;
      flex: 1;
      .lv {
        
        font-size: 20px;
        font-weight: 600;
        line-height: 23.87px;
        letter-spacing: -0.02em;
        text-align: left;
      }
      .break {
        
        font-size: 10px;
        font-weight: 400;
        line-height: 11.93px;
        text-align: left;
      }

      .break-time {
        margin-top: 4px;
        
        font-size: 15px;
        font-weight: 700;
        line-height: 17.9px;
        text-align: left;
      }
    }
  }

  .title {
    
    font-size: 15px;
    font-weight: 700;
    line-height: 17.9px;
    text-align: left;
  }

  .sub-title {
    font-size: 12px;
    
    color #909090;
    font-weight: 500;
    padding-left: 3px;
  }

  .player {
    
    font-size: 10px;
    font-weight: 300;
    line-height: 11.93px;
    text-align: right;
    span {
      
      font-size: 10px;
      font-weight: 600;
      line-height: 11.93px;
      text-align: right;
    }
  }
`;

const Button = styled.div<{
  isOpen: boolean;
  isReservation: boolean;
}>`
  flex: 1;
  position: relative;
  border-radius: 8px;
  color: white;
  text-align: center;

  font-size: 15px;
  font-weight: 600;
  line-height: 17.9px;
  letter-spacing: -0.16500000655651093px;
  text-align: center;
  padding: 8.5px 0px;
  background: var(--Purple-300, rgba(100, 54, 231, 1));

  background: ${(p) =>
    p.isReservation
      ? "#D91818"
      : p.isOpen
      ? "var(--Purple-300, rgba(100, 54, 231, 1))"
      : "rgba(217, 217, 217, 1)"};
`;

const ReservationButtonWrapper = styled.div`
  display: flex;
  gap: 9px;
  width: 100%;
  align-items: center;
  margin-top: 8px;

  > .state-button {
    display: flex;
    flex-direction: column;

    > img {
      width: 31px;
      height: 31px;
    }

    > .count {
      font-weight: 600;
      font-size: 10px;
      text-align: center;
    }
  }
`;
const CircularProgress = styled.svg`
  width: 57px;
  height: 57px;
  border-radius: 50%;
  transform: rotate(0.25turn);

  circle {
    fill: none;
    stroke-width: 8;
  }

  .background {
    stroke: #fff;
  }

  .progress {
    transition: stroke-dashoffset 0.35s;
    transform: scaleX(-1);
    transform-origin: center;
  }
`;

interface TournamentInfoProps {
  item: PubTournament;
  timer: TimerInfoState;
  pubType: PubType;
  setIsReservationCancelItem: (value: CurrentReservation) => void;
  setIsReservationCancel: (value: boolean) => void;
}

const PremiumExtraInfo: React.FC<TournamentInfoProps> = ({
  item,
  timer,
  pubType,
  setIsReservationCancelItem,
  setIsReservationCancel,
}) => {
  const history = useHistory();
  const user = useRecoilValue(userState);
  const [level, setLevel] = useState(0);
  const [isReservation, setIsReservation] = useState<boolean>(false);
  const [isSpecial, setIsSpecial] = useState<boolean>(false);
  const [current, setCurrent] = useState<CurrentReservation | null>(null);

  useEffect(() => {
    if (item.timeInfo.currentLevel.level === null) {
      setLevel(item.timeInfo.nextLevel?.level - 1);
    } else {
      setLevel(item.timeInfo.currentLevel.level);
    }

    if (item.current && user) {
      const current = item.current.find(
        (current) => current.userId === user.id
      );
      if (current) {
        setIsReservation(true);
        setIsSpecial(current.route === "SPECIAL");
        setCurrent(current);
      } else {
        setIsReservation(false);
        setIsSpecial(false);
        setCurrent(null);
      }
    }
  }, [item]);

  const canReservation = (pubTournament: PubTournament): boolean => {
    if (!pubTournament.reservation) {
      return false;
    }

    const currentLevel = pubTournament.timeInfo.currentLevel.level;
    if (currentLevel) {
      if (pubTournament.registerDeadlineLevel >= currentLevel) {
        return true;
      }
    } else {
      if (pubTournament.registerDeadlineLevel >= level) {
        return true;
      }
    }

    return false;
  };

  const radius = 28.5;
  const circumference = 2 * Math.PI * radius;

  const getEntryButtonText = (): string => {
    const totalCapacity =
      item.adOnUserCount + item.entryUserCount + item.reBuyInUserCount;

    if (item.reservation && !item.isEnd && item.timeInfo.elapsedTimeMs < 0) {
      return makeReservationButtonText();
    }

    return `${item.userCount}/${totalCapacity}명`;
  };

  const makeReservationButtonText = () => {
    if (item.reservation?.limitEntry) {
      return `${item.numberOfReservation}/${item.reservation.limitEntry}명`;
    }
    return `${item.numberOfReservation}명`;
  };

  const getReservationButtonText = (): string => {
    // 예약이 있는 경우
    if (item.reservation) {
      if (isReservation) {
        return "예약취소";
      }
      if (!canReservation(item)) {
        return "레지마감";
      }
      return `예약하기`;
    }
    // 예약이 없는 경우
    if (!item.isEnd && item.timeInfo.elapsedTimeMs > 0) {
      return `토너먼트 진행 현황`;
    }
    return "시작 준비 중";
  };

  const formatTime = (value: string) => {
    if (value.includes("hour")) {
      if (+value.split("hour")[0] <= 24) {
        return value;
      }
      const day = (+value.split("hour")[0] / 24).toFixed();
      return `${day}day`;
    }
    return value;
  };

  return (
    <TournamentWrapper progress={timer?.progress ? timer?.progress : 0}>
      <div className="content">
        <div className="row">
          <div className="title">{item.title}</div>
          <div className="player">
            PLAYERS{" "}
            <span>{` ${item.userCount}/${
              item.entryUserCount + item.reBuyInUserCount + item.adOnUserCount
            }`}</span>
          </div>
        </div>
        {item.subTitle && <div className="row sub-title"> {item.subTitle}</div>}
        <div className="row time-lv">
          <div className="time-box">
            <CircularProgress>
              <circle className="background" r={28.5} cx="28.5" cy="28.5" />
              <circle
                className="progress"
                r={28.5}
                cx="28.5"
                cy="28.5"
                stroke="url(#gradient)"
                strokeWidth="5"
                strokeDasharray={circumference}
                strokeDashoffset={
                  timer.currentLevel.type === "READY"
                    ? 0
                    : (circumference * -timer.progress) / 100
                }
              />
              <defs>
                <radialGradient
                  id="gradient"
                  cx="95%"
                  cy="50%"
                  r="80%"
                  fx="100%"
                  fy="50%"
                >
                  <stop offset="0%" stopColor="#FFFFFF" />
                  <stop offset="49.5%" stopColor="#FF8787" />
                  <stop offset="100%" stopColor="#FF0000" />
                </radialGradient>
              </defs>
            </CircularProgress>
            <div className="time">
              {formatTime(timer.remainingTimeInCurrentLevel)}
            </div>
          </div>

          <div className="col lv-col">
            <div className="lv">
              {timer.currentLevel.type === "BREAK"
                ? "BREAK"
                : timer.currentLevel.type === "READY"
                ? "준비중"
                : `LV ${timer.currentLevel.level}`}
            </div>
            <div className="row blind-col">
              <div className="col current">
                <div className="blind-name">
                  {`${
                    timer.currentLevel.type === "READY" ? "시작" : "현재"
                  } BLIND`}{" "}
                </div>
                <div className="blind">
                  {timer.currentLevel.type === "BREAK"
                    ? "BREAK"
                    : `${timer.currentLevel.smallBlind} / ${timer.currentLevel.bigBlind} (${timer.currentLevel.ante})`}
                </div>
              </div>
              <div className="col next">
                <div className="blind-name">다음 BLIND</div>
                <div className="blind">
                  {timer.nextLevel?.type === "BREAK"
                    ? "BREAK"
                    : `${timer.nextLevel?.smallBlind} / ${timer.nextLevel?.bigBlind} (${timer.nextLevel?.ante})`}
                </div>
              </div>
            </div>
          </div>
        </div>

        <ReservationButtonWrapper>
          <div
            className="state-button"
            onClick={() => {
              if (
                item.reservation &&
                !item.isEnd &&
                item.timeInfo.elapsedTimeMs < 0
              ) {
                if (isRunner(pubType)) {
                  history.push(`/company-reservation/${item.reservation!.id}`);
                  return;
                } else {
                  history.push(`/reservation/${item.reservation!.id}`);
                  return;
                }
              }
              history.push(`/tournament/${item.id}`);
            }}
          >
            <img src="/image-web/reservation/state_button.svg" alt="To Map" />
            <div className="count">{getEntryButtonText()}</div>
          </div>
          <Button
            isOpen={item.reservation ? canReservation(item) : true}
            isReservation={isReservation}
            onClick={() => {
              if (!item.reservation) {
                history.push(`/tournament/${item.id}`);
                return;
              }
              if (isReservation && current) {
                const data = {
                  ...current,
                  tournament: item,
                };
                if (isSpecial) {
                  enqueueSnackbar(
                    "특별초대권으로 예약된 토너먼트는 취소할 수 없습니다. ",
                    { variant: "error" }
                  );
                  return;
                }
                setIsReservationCancelItem(data);
                setIsReservationCancel(true);
                return;
              }
              if (canReservation(item)) {
                if (isRunner(pubType)) {
                  history.push(`/company-reservation/${item.reservation!.id}`);
                } else {
                  history.push(`/reservation/${item.reservation!.id}`);
                }
              }
            }}
          >
            {getReservationButtonText()}
          </Button>
        </ReservationButtonWrapper>
      </div>
    </TournamentWrapper>
  );
};

export default PremiumExtraInfo;
